/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1902247945 — FailureScreen */

import { useTranslation } from 'react-i18next';

import { useEffect, useState } from 'react';
import { ERROR_MESSAGES } from '../../../../shared/constants';
import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { usePageTracking } from '../../../../shared/hooks/usePageTracking';
import { usePurchaseActions } from '../../../../shared/hooks/usePurchaseActions';
import { readPaymentFailureCode } from '../../lib/payment-failure';
import { Button, ContentBox, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { FeedbackCustom } from '../../../../shared/layouts/FeedbackButtonLogic/FeedbackButtonLogic';
import { AnimatedIcon } from '../../../../shared/ui/AnimatedIcon/AnimatedIcon';
import crossAnimation from '../../../../shared/ui/AnimatedIcon/animations/cross.json';
import styles from './FailureScreen.module.css';

interface FailureScreenProps {
    title?: string;
    screenName: string;
}

const FailureScreen = ({ title, screenName }: FailureScreenProps) => {
    const { t } = useTranslation();
    const { onRepeatPurchaseClickHandler } = usePurchaseActions();
    const order = useAppStore((s) => s.order);
    const [paymentError, setPaymentError] = useState('');

    usePageTracking(title || 'failure');

    useEffect(() => {
        const errorCode = readPaymentFailureCode(order.extra);
        if (errorCode) {
            setPaymentError(
                ERROR_MESSAGES[errorCode] || String(t('Payment Error')),
            );
        }
    }, []);

    return (
        <ScreenWrapper>
            <ScreenTitle>{t(title || 'Failed sale')}</ScreenTitle>
            <ContentBox>
                {paymentError && (
                    <div className={styles.priceExplanation}>
                        {t(paymentError)}
                    </div>
                )}
                <AnimatedIcon
                    loop={false}
                    animationData={crossAnimation}
                    className={styles.animationWrapper}
                />

                <FeedbackCustom />

                <Button onClick={() => onRepeatPurchaseClickHandler(screenName)}>
                    {t('Repeat_purchase')}
                </Button>
            </ContentBox>
        </ScreenWrapper>
    );
};

export { FailureScreen };
